import { MenuTabsWrap } from 'features/menu/components/menu-tabs';
import { MenuRecentItemsPage } from 'features/menu/pages/recent-items-page';
import { useStoreRequired } from 'features/store/hooks/use-store-required';

export default function MenuScreen() {
  useStoreRequired();

  return (
    <MenuTabsWrap>
      <MenuRecentItemsPage />
    </MenuTabsWrap>
  );
}
